import { Banner } from "@community-project-org/ui";
import { useQuery } from "@tanstack/react-query";
import { BadgeCheck } from "lucide-react";
import type { JSX } from "react";

import { apiRequest } from "../../common/api/apiClient.js";
import type { components } from "../../generated/api.js";

type MemberBenefitDTO = components["schemas"]["MemberBenefitDTO"];

/** Was der eigene Ausweis hier bringt. Verbindlich ist der Preis der Buchung. */
export function benefitText(benefit: MemberBenefitDTO): string {
  const parts: string[] = [];
  if (benefit.freeLeft !== null && benefit.freeLeft > 0) {
    parts.push(`${benefit.freeLeft} ${benefit.freeLeft === 1 ? "freie Buchung" : "freie Buchungen"} übrig`);
  }
  if (benefit.discountPercent > 0) {
    parts.push(`${benefit.discountPercent} % Rabatt`);
  }
  if (benefit.earlyAccess) {
    parts.push("Vorverkauf für Mitglieder");
  }
  return parts.join(" · ");
}

/** Hinweis auf der Angebotsseite, nur wenn ein Ausweis hier etwas bringt. */
export function MemberBenefitNote({ serviceId }: { serviceId: string }): JSX.Element | null {
  const benefits = useQuery({
    queryKey: ["member-benefits", serviceId],
    queryFn: () =>
      apiRequest<MemberBenefitDTO[]>(`/my/member-benefits/${encodeURIComponent(serviceId)}`, { tenant: null }),
  });
  const shown = (benefits.data ?? []).filter((benefit) => benefitText(benefit));
  if (shown.length === 0) {
    return null;
  }
  return (
    <Banner tone="brand" icon={<BadgeCheck aria-hidden="true" />} title={`Mitglied: ${shown.map((b) => b.planName).join(", ")}`}>
      {shown.map((benefit) => benefitText(benefit)).join(" — ")}
    </Banner>
  );
}
